import type { MessageDescriptor } from 'react-intl';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faMusic } from '@fortawesome/pro-light-svg-icons/faMusic';
import { faListMusic } from '@fortawesome/pro-light-svg-icons/faListMusic';
import { faNewspaper } from '@fortawesome/pro-light-svg-icons/faNewspaper';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faRadio } from '@fortawesome/pro-light-svg-icons/faRadio';
import { faPodcast } from '@fortawesome/pro-light-svg-icons/faPodcast';
import { faVideo } from '@fortawesome/pro-light-svg-icons/faVideo';
import type { OutreachPitchKind } from 'fym-shared/src/music24/outreach/dailyPitches';
import { whoMessages as messages } from './whoMessages';

/** The rows of "Who Plug looks for" (design outreach-v2 c1), in the order of the frame. */
export const KIND_COPY: Record<
  OutreachPitchKind,
  { icon: IconDefinition; title: MessageDescriptor; sub: MessageDescriptor }
> = {
  spotifyPlaylist: { icon: faMusic, title: messages.kindSpotifyPlaylist, sub: messages.kindSpotifyPlaylistSub },
  otherPlaylist: { icon: faListMusic, title: messages.kindOtherPlaylist, sub: messages.kindOtherPlaylistSub },
  press: { icon: faNewspaper, title: messages.kindPress, sub: messages.kindPressSub },
  newsletter: { icon: faEnvelope, title: messages.kindNewsletter, sub: messages.kindNewsletterSub },
  radio: { icon: faRadio, title: messages.kindRadio, sub: messages.kindRadioSub },
  podcast: { icon: faPodcast, title: messages.kindPodcast, sub: messages.kindPodcastSub },
  creator: { icon: faVideo, title: messages.kindCreator, sub: messages.kindCreatorSub },
};
